import { render, staticRenderFns } from "./SiteLink.vue?vue&type=template&id=38c4916d&scoped=true"
import script from "./SiteLink.vue?vue&type=script&lang=ts"
export * from "./SiteLink.vue?vue&type=script&lang=ts"
import style0 from "./SiteLink.vue?vue&type=style&index=0&id=38c4916d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4916d",
  null
  
)

export default component.exports